import { inject, Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, map } from 'rxjs';
import { LoginRequestDto } from '../models/login-request.dto';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthloginService {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  login(data?: LoginRequestDto): void {
    const authOptions = data?.email
      ? { customParams: { login_hint: data.email, resource: environment.managementApiUrl, } }
      : undefined;

    this.oidcSecurityService.authorize(undefined, authOptions);
  }

  logout(): void {
    this.oidcSecurityService.logoff().subscribe();
  }

  isAuthenticated$(): Observable<boolean> {
    return this.oidcSecurityService.isAuthenticated$.pipe(
      map((result) => result.isAuthenticated),
    );
  }

  getAccessToken(): Observable<string> {
    return this.oidcSecurityService.getIdToken();
  }
}
